(function () {
  'use strict';
  angular.module('vcdms.vcscan')
    .component('scancounter', {
      restrict: 'E',
      bindings: {},
      template: `
        <span class="badge badge-warning" ng-bind="vm.counter"  uib-tooltip="Neue Scans zu sortieren"  tooltip-placement="auto"></span>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'Rlog', 'vertxEventBusService', '$http',
        function ($log, File, Rlog, vertxEventBusService, $http) {
          let vm = this;

          vm.$onInit = function () {
            getCounter();
          }; // $onInit()

          function getCounter() {
            let query = [{
              $match: {
                scanstatus: 'captured',
                active: true
              }
            }, {
              $group: {
                _id: null,
                counter: {$sum: 1}
              }
            }];

            $http.post('/routes/files/aggregate', query).then(res => {
              vm.counter = 0;
              if (res.data.counter) {
                vm.counter = res.data.counter;
              }
            }, err => {
              $log.error('scancounter.$aggregate failed: ', err);
              Rlog.error('dms.scan', 'scancounter', 'scancounter.$aggregate failed', {});
            });
          }


          // listen for files updates
          vertxEventBusService.on('scanfile.update', function () {
            getCounter();
          });
          vertxEventBusService.on('file.update', function () {
            getCounter();
          });
          vertxEventBusService.on('file.create', function () {
            getCounter();
          });

        }
      ] // controller
    }); // component

// klammerfriedhof
}());
